import React from 'react'
import { FormInput, FormButton } from '@myxplor/forms'
import { PlusIcon, DeleteIcon } from '@myxplor/icons'

import { TypeAheadSelect } from '../../../../ui/forms/type-ahead'
import Grid from '../../../../ui/grid'
import { businessType } from './states'

const defaultValue = {
  businessType: undefined,
  businessName: undefined,
  ABN: undefined,
  RTORegistrationCode: undefined,
}

export const defaultValues = {
  OtherEnterprise: [],
}

export const OtherService = ({
  onChange,
  addKey,
  removeKey,
  errorAtKey,
  values = {},
  errors = {},
}) => (
  <div>
    <fieldset>
      <legend>Interest in business related to Child Care</legend>
        Has the person owned or had any interest in a Registered Training Organisation (RTO) or any
        other business enterprise associated with child care
    </fieldset>

    {values.OtherEnterprise.map((service = {}, i) => (
      <div className="formValues--nested" key={i}>
        <fieldset>
          <legend>Name and Type</legend>
          <Grid>
            <TypeAheadSelect
              name={`OtherEnterprise[${i}].businessType`}
              value={service.businessType}
              errors={errorAtKey({ key: `OtherEnterprise[${i}].businessType`, errors })}
              label="Type of business"
              options={businessType}
              onChange={onChange}
              required
              compact
            />

            <FormInput
              name={`OtherEnterprise[${i}].businessName`}
              value={service.businessName}
              errors={errorAtKey({ key: `OtherEnterprise[${i}].businessName`, errors })}
              label="Name of business"
              maxLength={120}
              onChange={onChange}
              required
              compact
            />

            <FormInput
              name={`OtherEnterprise[${i}].ABN`}
              value={service.ABN}
              errors={errorAtKey({ key: `OtherEnterprise[${i}].ABN`, errors })}
              label="ABN"
              hint="Australian Business Number"
              maxLength={11}
              onChange={onChange}
              required
              compact
            />

            <FormInput
              name={`OtherEnterprise[${i}].RTORegistrationCode`}
              value={service.RTORegistrationCode}
              label="RTO Registration Code"
              errors={errorAtKey({ key: `OtherEnterprise[${i}].RTORegistrationCode`, errors })}
              maxLength={20}
              onChange={onChange}
              required
              compact
            />
          </Grid>
        </fieldset>

        <FormButton
          destructive
          confirm={`Deleting ${service.serviceName ||
              'this service'} can not be undone. Are you sure?`}
          onClick={e => {
            e.preventDefault()
            removeKey(`OtherEnterprise[${i}]`)
          }}>
          <DeleteIcon left />
            Delete Ownership/Operation
        </FormButton>
      </div>
    ))}

    <FormButton
      onClick={e => {
        e.preventDefault()
        addKey('OtherEnterprise', { ...defaultValue })
      }}>
      <PlusIcon left />Add new Ownership/Operation
    </FormButton>
  </div>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/other-service.jsx